import { useEffect } from "react";

// Closes a popup/modal on Escape - calls the exact same handler as its
// visible Close button, so Escape can never behave differently (skip a
// confirm-before-close check, leave stale state, etc). No-ops while closed
// so background modals don't eat every other modal's Escape key.
export const useEscapeKey = (isOpen, onClose) => {
  useEffect(() => {
    if (!isOpen || !onClose) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);
};
